import {
  DetailedHTMLProps,
  ThHTMLAttributes,
  useRef,
  useEffect,
  CSSProperties,
} from 'react';
import * as S from './styles';

export interface TableHeaderCellProps
  extends DetailedHTMLProps<
    ThHTMLAttributes<HTMLTableHeaderCellElement>,
    HTMLTableHeaderCellElement
  > {
  setCellWidth?: (width: any) => void;
  fontSize?: number;
  isFixed?: boolean;
  left?: CSSProperties['left'];
  index: number;
  fixedPosition?: 'left' | 'right';
}

function TableHeaderCell({
  children,
  setCellWidth = () => {},
  index,
  ...rest
}: TableHeaderCellProps) {
  const thRef = useRef<HTMLTableHeaderCellElement>(null);

  useEffect(() => {
    const updateCellWidth = () => {
      if (thRef.current) {
        const width = thRef.current.offsetWidth;
        setCellWidth((widthArray) =>
          widthArray?.map((v, i) => (index === i ? `${width}px` : v)),
        );
      }
    };

    window.addEventListener('resize', updateCellWidth);
    updateCellWidth();
    return () => {
      window.removeEventListener('resize', updateCellWidth);
    };
  }, []);

  return (
    <S.CellHead ref={thRef} {...rest}>
      {children}
    </S.CellHead>
  );
}
export default TableHeaderCell;
